import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import manifest from '../manifest.json';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    if (lang !== 'de' && !lang.endsWith('/de') && lang !== 'en' && !lang.endsWith('/en')) {
      console.warn(`Unsupported language requested: ${lang}. Falling back to 'en'.`);
      lang = 'en';
    }
    return this.http.get<Translation>(`/i18n/${lang}.json?v=${manifest.commitId}`);
  }
}
